var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as moment from 'moment';
import { Loggeable } from '../../../../lib/common/loggeable.cls';
var FifoItemValidator = /** @class */ (function (_super) {
    __extends(FifoItemValidator, _super);
    /**
     * Contructor detail
     * save reference to provider
     * @param iProvider
     */
    function FifoItemValidator(iProvider) {
        var _this = _super.call(this) || this;
        /**
         * @Override
         *
         * validate a single cached item,
         * gets invoked by the ICache implementations
         * @param iCacheable the item to validate
         */
        _this.validate = function (iCacheable) {
            // this.log(FifoItemValidator.TAG, 'validate ', iCacheable)
            if ((iCacheable.maxAge + iCacheable.ts) <= _this.getNowMs()) {
                _this.iProvider.refresh(iCacheable);
            }
        };
        _this.iProvider = iProvider;
        return _this;
    }
    /**
     * @Override
     *
     * patch an expired item with new data
     * @param iCacheable the item to validate
     */
    FifoItemValidator.prototype.patchItem = function (oldItem, newItem) {
        var old = oldItem.item;
        if (newItem.A) {
            var buy_increase_staus = -1;
            var class_to_selected_buy = 'up';
            if (old.B > newItem.B) {
                buy_increase_staus = 0;
            }
            else {
                buy_increase_staus = 1;
            }
            var sell_increase_staus = -1;
            var class_to_selected_sell = 'down';
            if (old.A > newItem.A) {
                sell_increase_staus = 0;
            }
            else {
                sell_increase_staus = 1;
            }
            if (newItem.T.bs === undefined || newItem.T.ltq == '') {
                newItem.T.bs = old.T.bs;
            }
            if (newItem.T.ltq === undefined || newItem.T.ltq == '') {
                newItem.T.ltq = old.T.ltq;
            }
            if (newItem.T.ltp === undefined || newItem.T.ltp == '') {
                newItem.T.ltp = old.T.ltp;
            }
            if (newItem.T.ltt === undefined || newItem.T.ltt == '' || newItem.T.ltt == 'NA') {
                newItem.T.ltt = old.T.ltt;
            }
            if (newItem.T.op === undefined || newItem.T.op == '') {
                newItem.T.op = old.T.op;
            }
            if (newItem.T.tbq === undefined || newItem.T.tbq == '') {
                newItem.T.tbq = old.T.tbq;
            }
            if (newItem.T.tsq === undefined || newItem.T.tsq == '') {
                newItem.T.tsq = old.T.tsq;
            }
            if (newItem.T.v === undefined || newItem.T.v == '') {
                newItem.T.v = old.T.v;
            }
            if (newItem.T.h === undefined || newItem.T.h == '') {
                newItem.T.h = old.T.h;
            }
            if (newItem.T.lo === undefined || newItem.T.lo == '') {
                newItem.T.lo = old.T.lo;
            }
            if (newItem.T.c === undefined || newItem.T.c == '') {
                newItem.T.c = old.T.c;
            }
            if (newItem.T.bq === undefined || newItem.T.bq == '') {
                newItem.T.bq = old.T.bq;
            }
            if (newItem.T.oi === undefined || newItem.T.oi == '') {
                newItem.T.oi = old.T.oi;
            }
            if (newItem.T.yl === undefined || newItem.T.yl == '') {
                if (old.T.yl == undefined || old.T.yl == '') {
                    newItem.T.yl = "-";
                }
                else {
                    newItem.T.yl = old.T.yl;
                }
            }
            if (newItem.T.yh === undefined || newItem.T.yh == '') {
                if (old.T.yh == undefined || old.T.yh == '') {
                    newItem.T.yh = "-";
                }
                else {
                    newItem.T.yh = old.T.yh;
                }
            }
            newItem.buy_increase_staus = buy_increase_staus;
            newItem.sell_increase_staus = sell_increase_staus;
            oldItem.item = __assign(__assign({}, old), newItem);
        }
        else if (newItem.openrate) {
            if (old.A !== undefined) {
                oldItem.item.Other = newItem;
            }
        }
        else {
            console.log();
        }
    };
    // get current timestamp in milliseconds
    FifoItemValidator.prototype.getNowMs = function () {
        return moment().utc().valueOf();
    };
    // log tag
    FifoItemValidator.TAG = 'ItemValidator';
    return FifoItemValidator;
}(Loggeable));
export { FifoItemValidator };



//////////////////
// WEBPACK FOOTER
// ./src/plugins/vue-provider-cache/provider/ws-price-feed/cache/fifo-item-validator.cls.ts
// module id = null
// module chunks = 